import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { MeshDistortMaterial, Sphere, Float, Sparkles } from "@react-three/drei";

const AnimatedCyberOrb = () => {
  const meshRef = useRef();

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.x = state.clock.getElapsedTime() * 0.2;
      meshRef.current.rotation.y = state.clock.getElapsedTime() * 0.25;
    }
  });

  return (
    <Float speed={2} rotationIntensity={1} floatIntensity={2}>
      <Sphere args={[1, 64, 64]} ref={meshRef}>
        <MeshDistortMaterial
          color="#00f0ff"
          attach="material"
          distort={0.4}
          speed={1.5}
          roughness={0.2}
          metalness={0.8}
          wireframe={true}
          transparent={true}
          opacity={0.15}
        />
      </Sphere>
      <Sparkles count={100} scale={3} size={2} speed={0.4} opacity={0.5} color="#00f0ff" />
    </Float>
  );
};

const HeroOrb = () => {
  return (
    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 0, pointerEvents: "none" }}>
      <Canvas camera={{ position: [0, 0, 3], fov: 45 }}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[10, 10, 10]} intensity={2} color="#00f0ff" />
        <AnimatedCyberOrb />
      </Canvas>
      {/* Radial gradient mask to fade the edges */}
      <div style={{
        position: "absolute", inset: 0, 
        background: "radial-gradient(circle at center, transparent 30%, #06080f 70%)",
        zIndex: 1
      }} />
    </div>
  );
};

export default HeroOrb;
